//; -*-Web-*-
import Comp from '../lib/comp';
import React from 'react';
import fly from '../games/fly';
import ski from '../games/ski';

import randint from 'random-int';

import { playBg, loadAudio, fadeBgTo } from '../lib/audio';

const games = {
  fly, ski
}

const Game = Comp({
  displayName: 'game',

  getInitialState() {
    var newState = this.getScale();
    newState.w = 128;
    newState.h = 154;
    newState.showExit = false;
    return newState;
  },

  componentDidMount() {
    var ctx = this.canvas.getContext('2d');
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    console.log(this.props)
    this.game = games[this.props.game];
    this.game.init(this.canvas, this.state.w, this.state.h);

    playBg('/audio/game_music_' + randint(1, 3) + '.mp3');
    loadAudio(...['move_1', 'move_2', 'over', 'highscore', 'explosion_1', 'explosion_2'].map(a => `/audio/game_${a}.mp3`));

    window.addEventListener('orientationchange', this.setScale);
    window.addEventListener('resize', this.setScale);

    var evt = ('ontouchstart' in window ? 'touchstart' : 'mousedown');
    ['up', 'down', 'left', 'right', 'btn'].forEach(which => {
      this[which].addEventListener(evt, this[which + 'fn']);
    });

    document.addEventListener('keydown', this.key);

    this.canvas.addEventListener('click', this.btnfn);
    this.canvas.addEventListener('touchstart', this.touchstart);
    this.canvas.addEventListener('touchmove', this.touchmove);
    this.canvas.addEventListener('touchend', this.touchend);
  },

  key(e) {
    switch (e.which) {
      case 37:
        e.preventDefault();
        this.game.event('left');
        break;
      case 38:
        e.preventDefault();
        this.game.event('up');
        break;
      case 39:
        e.preventDefault();
        this.game.event('right');
        break;
      case 40:
        e.preventDefault();
        this.game.event('down');
        break;
      case 32:
      case 13:
        e.preventDefault();
        this.game.event('btn');
        break;
      default:
        /* console.log(e.which);*/
    }
  },

  touching: false,
  touchOrigin: null,
  currentTouch: null,

  touchstart(e) {
    e.preventDefault();
    this.touching = true;
    this.currentTouch = this.touchOrigin = [e.targetTouches[0].clientX, e.targetTouches[0].clientY];
  },

  touchmove(e) {
    e.preventDefault();
    if (this.touching) {
      this.currentTouch = [e.targetTouches[0].clientX, e.targetTouches[0].clientY];
      let deltaX = this.currentTouch[0] - this.touchOrigin[0];
      let deltaY = this.currentTouch[1] - this.touchOrigin[1];

      if (Math.abs(deltaY) > Math.abs(deltaX) / 2) {
        if (deltaY > 20) {
          this.game.event('down');
          this.touching = false;
        } else if (deltaY < -20) {
          this.game.event('up');
          this.touching = false;
        }
      } else if (Math.abs(deltaX) > Math.abs(deltaY) / 2) {
        if (deltaX > 20) {
          this.game.event('right');
          this.touching = false;
        } else if (deltaX < -20) {
          this.game.event('left');
          this.touching = false;
        }
      }
    }
  },

  touchend(e) {
    e.preventDefault();
    if (this.touching) {
      let deltaX = this.currentTouch[0] - this.touchOrigin[0];
      let deltaY = this.currentTouch[1] - this.touchOrigin[1];
      if (deltaX < 10 && deltaY < 10) {
        this.game.event('btn');
      }
      this.touching = false;
    }
  },

  upfn(e) {
    e.preventDefault();
    this.game.event('up');
  },
  downfn(e) {
    e.preventDefault();
    this.game.event('down');
  },
  leftfn(e) {
    e.preventDefault();
    this.game.event('left');
  },
  rightfn(e) {
    e.preventDefault();
    this.game.event('right');
  },
  btnfn(e) {
    e.preventDefault();
    this.game.event('btn');
  },

  getScale() {
    var xscale = Math.min(window.innerWidth / 403, 1);
    var yscale = Math.min(window.innerHeight / 666, 1);

    if (xscale <= yscale) {
      var margin = Math.max(0, Math.min(26, (455 - window.innerWidth) / 2));
      var topmargin = margin / 26 * 45;
      return {
        marginSide: -margin * xscale,
        marginTop: -topmargin * xscale,
        scale: xscale
      };

    } else {
      var topmargin = Math.max(0, Math.min(45, (711 - window.innerHeight)))
      var margin = topmargin / 45 * 26;
      var marginSide = (-margin * yscale) + (window.innerWidth - (455 - (margin * 2)) * yscale) / 2;

      return {
        marginSide: marginSide,
        marginTop: -topmargin * yscale,
        scale: yscale
      };
    }
  },

  setScale() {
    this.setState(this.getScale());
  },

  componentWillUnmount() {
    this.game.stop();
    window.removeEventListener('orientationchange', this.setScale);
    window.removeEventListener('resize', this.setScale);
    var evt = ('ontouchstart' in window ? 'touchstart' : 'mousedown');
    ['up', 'down', 'left', 'right', 'btn'].forEach(which => {
      this[which].removeEventListener(evt, this[which + 'fn']);
    });
    fadeBgTo(1);
    document.removeEventListener('keydown', this.key);

    this.canvas.removeEventListener('click', this.btnfn);
    this.canvas.removeEventListener('touchstart', this.touchstart);
    this.canvas.removeEventListener('touchmove', this.touchmove);
    this.canvas.removeEventListener('touchend', this.touchend);
  },

  render() {
    return (<div className="c-game" style={{
      marginLeft: this.state.marginSide,
      marginRight: this.state.marginSide,
      marginTop: this.state.marginTop
    }}>
      <div className="c-game__wrap">
        <div className="c-game__console" style={{
          transform: `scale(${this.state.scale})`
        }}>
          <canvas width={this.state.w} height={this.state.h} ref={c => this.canvas = c} style={{
            width: this.state.w * 3,
            height: this.state.h * 3
          }} />
          <div className="c-game__console__btn c-game__console__btn--up"    ref={el => this.up    = el}></div>
          <div className="c-game__console__btn c-game__console__btn--down"  ref={el => this.down  = el}></div>
          <div className="c-game__console__btn c-game__console__btn--left"  ref={el => this.left  = el}></div>
          <div className="c-game__console__btn c-game__console__btn--right" ref={el => this.right = el}></div>
          <div className="c-game__console__btn c-game__console__btn--btn"   ref={el => this.btn   = el}></div>
        </div>
      </div>
    </div>);
  }
});

export default Game;
